import ModuleContext from 'CMFW/context/ModuleContext';
import { LoadingItem } from 'CMFW/layout/Loading';
import { CardContainer, CardHeader, CardId } from 'components/common/styles';
import { IRefIds } from 'constants/refs';
import { useForceRender } from 'hooks/useForceRender';
import CulturalVocCardModel from 'models/CulturalVocCardModel';
import React, { useContext, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { tabsOpened } from 'store/actions/tabs';
import { IAppState } from 'store/reducers/rootReducer';
import styled from 'styled-components';
import { ICulturalVocCard } from 'types/content';

type IProps = {
  id: number;
};

const CulturalVocCard: React.FC<IProps> = (props) => {
  const { id } = props;

  const forceRender = useForceRender();
  const dispatch = useDispatch();
  const moduleModel = useContext(ModuleContext);
  
  const sourceDialect = useSelector((state: IAppState) => {
    if (moduleModel.courseId === 0) {
      return 2; // US dialect for courseId 0
    }
    return state.courseConfig[moduleModel.courseId]?.sourceDialectDefaultId || 2;
  });

  const culturalVocCardModel = useMemo(() => new CulturalVocCardModel({ render: forceRender, culturalVocId: id }), [
    forceRender,
    id,
  ]);

  const cardData = culturalVocCardModel.getItemValue('cardData') as ICulturalVocCard | undefined;

  const handleIdClick = () => {
    dispatch(
      tabsOpened({
        refId: IRefIds.cultural,
        search: id.toString(),
        courseId: moduleModel.courseId,
      }),
    );
  };

  if (!cardData) {
    return null;
  }

  return (
    <ModuleContext.Provider value={culturalVocCardModel}>
      <CardContainer key={id}>
        <CardHeader>
          <CardId onClick={handleIdClick}>{id}</CardId>
          <Title>{cardData.name}</Title>
        </CardHeader>
        <Content>
          {cardData[sourceDialect + '(s)'] && (
            <Description>{cardData[sourceDialect + '(s)']}</Description>
          )}
          {cardData.gender && <Gender>Gender: {cardData.gender}</Gender>}
          {cardData.wordClassCode && <WordClass>Word Class: {cardData.wordClassCode}</WordClass>}
        </Content>
        <LoadingItem />
      </CardContainer>
    </ModuleContext.Provider>
  );
};

const Title = styled.div`
  margin: 2px;
  font-size: 16px;
  font-weight: 600;
  flex: 1;
`;

const Content = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Gender = styled.div`
  font-size: 14px;
  color: #666;
`;

const WordClass = styled.div`
  font-size: 14px;
  color: #666;
`;

const Description = styled.div`
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
  line-height: 1.4;
`;

export default CulturalVocCard;
